import { useCallback } from 'react';
import { toast } from 'sonner';
import { useLanguage } from '../contexts/LanguageContext';

/**
 * Hook for displaying localized error toasts
 * 
 * Usage:
 *   const showError = useErrorToast();
 *   showError('failedToLoadPilots', err);
 *   
 * Or with custom message:
 *   showError('failedToUpdate', err, 'pilota');
 */
export const useErrorToast = () => {
  const { t } = useLanguage();
  
  return useCallback((errorKey, errorObj, context) => {
    // Get translated message from t.errors
    const message = t.errors?.[errorKey] || t.errors?.networkError || 'An error occurred';
    
    // Get detail from error response if available
    const detail = errorObj?.response?.data?.detail;
    
    // Build final message
    let finalMessage = message;
    if (context) {
      finalMessage = `${message}: ${context}`;
    } else if (detail) {
      finalMessage = `${message}: ${detail}`;
    }
    
    toast.error(finalMessage);
  }, [t]);
};

export default useErrorToast;
